export default "__VITE_ASSET__CYZRphyB__"